import(/* webpackMode: "eager" */ "/app/packages/apps/maui/app/(public)/product/error.tsx");
